export default __webpack_public_path__ + "static/media/ellipse-3.5590c662.svg";